// TODO: set up react ssr
// TODO: optimize core-js/tslib/regenerator-runtime/objectFitPolyfill loading conditionally in webpack config

import 'antd/dist/reset.css';

// Avoid importing more modules than necessary here;
// init base and lazy-load components as needed
import React from 'react';
import { createRoot } from 'react-dom/client';
// polyfill
import 'setimmediate';

import { createLogger } from '@owl-lib/logger';

import AppContainer from './context/AppContainer/AppContainer';
import AppProvider from './context/AppProvider';
import ReduxProvider from './context/ReduxProvider';
import store from './data/store';
import './styles/index.scss';

const logger = createLogger(__filename);

async function printVersions() {
  logger.info(
    { revision: process.env.OWL_REVISION },
    'Owl client version %s',
    process.env.OWL_VERSION
  );
}
// eslint-disable-next-line promise/catch-or-return
printVersions();

const container = document.getElementById('owl-frontend-app-phoenix-root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ReduxProvider reduxStore={store.reduxStore}>
      <AppProvider>
        <AppContainer />
      </AppProvider>
    </ReduxProvider>
  </React.StrictMode>
);
